module.exports = __webpack_public_path__ + "28c28683677f8347081c7897012b78f0.jpg";